/**
 * Which closed gatherings are still waiting for somebody to look at them — T19 of the
 * F-004 plan.
 *
 * Ported from `legacy/frontend/src/review.ts` at legacy commit 2953e3f, in its own order:
 * the doc comment, then the import, then the function. Nineteen lines, of which exactly
 * one is not theirs — the import below, because `ClosedSession` is a server shape and
 * nothing outside `packages/contracts/` may define or re-export one (ADR-0011). The old
 * app reads it from `./api`, where the old client declares it.
 *
 * **No list can hold this file whole, and the seam is why.** `scripts/verbatim.txt` means
 * byte-identical, which it cannot be; `scripts/ported-partial.txt` means «ours above a seam,
 * theirs below», and here the one changed line is legacy line **15 of 19** — theirs above it
 * and theirs below it. That is `FND-045`'s problem in a second shape, and FND-045 named the
 * second one as its trigger, so `FND-049` raises it rather than this file solving it with a
 * list format nobody has agreed to.
 *
 * What is held to the original in the meantime is the **doc comment**, their lines 1-13, as
 * one region on `scripts/ported-partial.txt`: nothing but a human's eye can check a comment,
 * and losing it is what `.claude/rules/styling.md` calls destroying information the rebuild
 * cannot recover. The three lines of the function are on no list — they are what the tests
 * in `screens/SessionsScreen.test.tsx` («the machine-closed alert») assert, the filter and
 * both of its flags.
 */

/**
 * Which closed gatherings are waiting for somebody to look at them.
 *
 * The scheduler closes a rehearsal whose two hours ran out and writes an
 * absence for everybody who never checked in. Nobody has confirmed any of it,
 * and the rule for "нужно проверить" is exactly two flags: the machine did it,
 * and the edit window has not run out yet. A rehearsal nobody can edit any
 * more is history whether it was reviewed or not.
 *
 * Its own module because two screens ask the same question - the banner at the
 * top of the schedule and the badge on «Посещаемость» - and the day the rule
 * changes it must not change in one of them.
 */

import type { ClosedSession } from '@contracts/index';

export function needingReview(sessions: ClosedSession[]): ClosedSession[] {
  return sessions.filter((item) => item.needs_review && item.can_edit);
}
